// AI 모델 설정(계약 §10, 대표). GET /model 은 행이 없으면 404 — 그때는 null.
import { http, data } from "../../inquiry/v6Api";

export async function getModel() {
    try { return await data(http.get("/model")); }
    catch (e) { if (e?.response?.status === 404) return null; throw e; }
}
export const saveModel = (body) => data(http.put("/model", body));
